import $ from 'jquery'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { nextUID } from '~/plugins/helper'
import TabOrder from '../statics/taborder-functions'
import { toRaw, isReactive } from 'vue'
import _Logger from './logger'
import Socket from './signalr'
import Nk_anime from "@/plugins/anime"
import Snapshot from '~/plugins/snapshot'
import jalaliMoment from 'jalali-moment'

export const convertDateByJalaliMoment = (date) => jalaliMoment(date, 'YYYY/MM/DD').locale('fa')

export const convertDate = (date, fullDate = true) => {
  if (fullDate)
    return new Date(date).toLocaleTimeString('fa-IR', { hour: 'numeric', minute: 'numeric' }).toString().toLocaleDigits() + '  ' + new Date(date).toLocaleDateString('fa-IR').toString().toLocaleDigits()
  else
    return new Date(date).toLocaleDateString('fa-IR').toString().toLocaleDigits()
}
export const convertDateToFromNow = (date) => {
  let duration = ((new Date()).getTime() - (new Date(date)).getTime()) / 1000
  if (duration / 60 < 1) return 'همین الان'
  else if (duration > 60 && duration < 3600) return `${Math.floor(duration / 60) ? Math.floor(duration / 60) : 1} دقیقه پیش`
  else if (duration < 86400) return `${Math.floor(duration / 3600) ? Math.floor(duration / 3600) : 1} ساعت پیش`
  else if (duration < 604800) return `${Math.floor(duration / 86400) ? Math.floor(duration / 86400) : 1} روز پیش`
  else if (duration < 2419200) return `${Math.floor(duration / 604800) ? Math.floor(duration / 604800) : 1} هفته پیش`
  else return convertDate(date, false)
}
const NikanMixin = {


  install(Vue, options) {
    Vue.mixin({
      emits: ['title-changed', 'buttons-changed', 'resolve', 'reject'],
      data() {
        return {
          localUID: 0,
          isShortcutVisible: false,
          grandParent: null,
          logger: new _Logger(),
          snapshotInstance: null,
          FORM_MODES: {
            EDITABLE: 'editable',
            READONLY: 'readonly'
          }
        }
      },
      computed: {
        ...mapGetters('useraccount', ['currentUserDetails']),
        ...mapGetters('properties', {
          'getPropertiesByGroup': 'getByGroup'
        })
      },
      created() {
        if (this.$options.sockets) {
          const methods = Object.getOwnPropertyNames(this.$options.sockets)

          methods.forEach((method) => {
            if (Socket.listenedItems().indexOf(method) === -1) {
              Socket.listen(method)
              Socket.on(method, data => {
                return this.$options.sockets[method].call(this, data)
              })
            }
          })
        }

        if (this.$options.subscribe) {
          Socket.on('authenticated', () => {
            this.$options.subscribe.forEach((channel) => {
              Socket.invoke('join', channel)
            })
          })
        }

        this.snapshotInstance = new Snapshot(this.snapshot, 300)
      },
      beforeUnmount() {
        if (this.snapshotInstance.state.initialized)
          this.snapshotInstance.clearInterval(this.snapshotInstance.state.intervalId)
      },
      mounted() {
        this.grandParent = this.findGrandParent()
        this.defer(this.applySubscribeKeys, 5)
        TabOrder.updateDisableds()

        Vue.$nikan.calcAutoHeight(this.$el)
        this.setTestId()
      },
      updated() {
        Vue.$nikan.calcAutoHeight(this.$el)
        TabOrder.updateDisableds()
      },
      methods: {
        uid() {
          if (this.localUID === 0) {
            this.localUID = nextUID()
          }

          return this.localUID
        },

        defer(func, wait) {
          var args = Array.from(arguments)
          if (args.length > 2) {
            args = _.drop(args, 2)
          } else {
            args = []
          }

          var that = this
          return setTimeout(() => {
            func.apply(that, args)
          }, wait)
        },
        // debounce(func, wait) {
        //   return _.debounce(func, wait)
        // },
        throttle(func, wait) {
          return _.throttle(func, wait)
        },
        parentForShortKey() {
          return $(this.$el).parents('.parent-for-adding-short-keys')
        },
        findGrandParent() {
          var modal = $(this.$el).parents('.modal-item-locker')
          if (modal.length > 0) {
            return modal
          } else {
            var tab = $(this.$el).parents('.tabs-component-panel')
            if (tab.length > 0) {
              return tab
            }
          }

          return this.$parent
        },
        grandParentType() {
          if ($(this.$el).parents('.nm-dim-inner').length > 0) {
            return 'modal'
          } else {
            if ($(this.$el).parents('.tabs-component-panel').length > 0) {
              return 'tab'
            }
          }

          return 'unknown'
        },
        applySubscribeKeys() {
          if (typeof this.subscribeKeys === 'function') {
            this.subscribeKeys()
          }
        },
        isObject(obj) {
          return Object.prototype.toString.call(obj) === '[object Object]'
        },
        typeChecker(variable) {
          if (typeof (variable) === 'string') {
            return 'string'
          } else if (this.isObject(variable)) {
            return 'object'
          }
          return 'array'
        },
        idGenerator(n) {
          return Math.random().toString(36).substr(2, n)
        },
        getDaysBetween(startDate = new Date(), endDate = new Date()) {
          if (!(endDate instanceof Date)) endDate = new Date(endDate)
          if (!(startDate instanceof Date)) startDate = new Date(startDate)
          let difference = endDate.getTime() - startDate.getTime()
          return Math.abs(Math.round(difference / (1000 * 3600 * 24)))
        },
        validationToast(errors) {
          if (!errors.length) return
          let errorComputedText = ''
          errors.map(err => errorComputedText += err.error + '\n')
          this.$toast(errorComputedText, { type: 'error', timeout: 10000, position: 'top-center' })
        },
        objGetKeyByValue(obj, value) {
          return Object.keys(obj).filter(key => obj[key] === value)[0]
        },
        findDiffrenceBetweenObjects(obj1, obj2) {
          let result = {
            result: 'same',
            fields: []
          }
          let objKeys = Object.keys(obj1)
          for (let key of objKeys) {

            if (!obj1.hasOwnProperty(key)) {
              result.result = 'different'
              result.fields.push(`${key} is not in obj1`)
              continue
            }

            if (!obj2.hasOwnProperty(key)) {
              result.result = 'different'
              result.fields.push(`${key} is not in obj2`)
              continue
            }

            if (!_.isEqual(obj1[key], obj2[key])) {
              result.result = 'different'
              result.fields.push(`${key} is not the same in obj1 and obj2`)
              continue
            }
          }
          return result
        },
        makeRawComponent(component) {
          if (isReactive(component))
            return toRaw(component)
          return component
        },
        routesAccessChecker(routes, parentToken) {
          return routes.map(route => {

            route.policyToken = _.isString(route.policyToken) ? [route.policyToken] : route.policyToken
            route.policyToken = route.policyToken || []

            if (route && route.items && route.items.length)
              this.routesAccessChecker(route.items, route.commercialAccess || parentToken)

            route.isDisabled = !this.$nikan.checkPermission(route.policyToken) || route.isDisabled
            route.hasCommercialAccess = true

            if (route.items && route.items.length)
              route.hasCommercialAccess = route.items.some(x => x.hasCommercialAccess)

            else {
              if (route.commercialAccess)
                route.hasCommercialAccess = this.$nikan.checkCommercialAccess(route.commercialAccess)

              else if (!route.commercialAccess && parentToken)
                route.hasCommercialAccess = this.$nikan.checkCommercialAccess(parentToken)
            }
          })
        },
        floatingCentersCellViewHtml(floatingCenters) {
          if (!floatingCenters || !floatingCenters.length)
            return ''

          let html = '<div class="floatingCenter_tags">'
          for (let fc of floatingCenters) {
            html += `<div class="tag ml-2">`
            html += `<div class="tag-content">`
            html += `<span class="code">${fc.code}</span>${fc.name}`
            html += `</div>`
            html += `</div>`
          }
          html += `</div>`
          return html
        },
        setTestId() {
          if (process.env.NODE_ENV !== 'development')
            return
          for (let r in this.$refs) {
            const ref = this.$refs[r]
            if (Array.isArray(ref)) {
              let i = 1
              for (let t of ref) {
                if (t.$el && typeof t.$el.setAttribute === 'function') {
                  t.$el.setAttribute('data-testid', r + i++)
                }
              }
            } else {
              if (ref.$el && typeof ref.$el.setAttribute === 'function') {
                ref.$el.setAttribute('data-testid', r)
              }
            }
          }
        },
        hideShortcuts() {
          $('.shortcut').attr('style', 'display: none !important')
          this.isShortcutVisible = false
        },
        displayShortcuts() {
          $('.shortcut').attr('style', 'display: block !important')
          this.isShortcutVisible = true
        },
        subscribeKeys() {
          this.$keyHandler.Subscribe({
            name: `shortcut-display`,
            keyCode: 18, // 18:Alt
            el: this.grandParent,
            context: this,
            handler: function (sender, e) {
              e.preventDefault()

              if (this.isShortcutVisible)
                this.hideShortcuts()

              else
                this.displayShortcuts()

            },
          })
        },
        convertDate(date, fullDate = true) {
          return convertDate(date, fullDate)
        },
        convertDateToFromNow(date) {
          return convertDateToFromNow(date)
        },
        ShowUpElementWithAnime(elementStatus, popupIdentifyClass, xDurationPixel = 70) {
          const anime = new Nk_anime(popupIdentifyClass, {
            translateX: xDurationPixel,
            translateY: 0,
            easing: 'linear',
            duration: 500,
          })
          const before_anime = new Nk_anime(popupIdentifyClass, {
            translateX: 0,
            // translateY: 80,
            easing: 'linear',
            duration: 500,
          })
          elementStatus ? anime.play() : before_anime.play()
        },
        vibrateElement(targetParentClass) {
          const anime = new Nk_anime(targetParentClass, {
            translateX: ['-.15rem', '.15rem'],
            duration: 75,
            direction: 'alternate',
            loop: 15,
            easing: 'easeInOutBack',
          })
          anime.play()
        },
        monify(x) {

          if (x !== 0 && !x)
            return ''

          var parts = x.toString().split(".")
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")

          if (parseInt(parts[1]) > 0)
            return parts.join(".")

          return parts[0]
        }
      }
    })
  }
}

export default NikanMixin
